module.exports = __webpack_public_path__ + "static/media/MenuDataSources.b05b833f.svg";